import { devToolsStatusBadgeVariants } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsStatusBadge/index.styles';
import type { DevToolsStatusBadgeProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsStatusBadge/index.types';
import React from 'react';
import { cn } from '~/lib/utils';

/**
 * DevToolsStatusBadge - A one-word verdict, tinted by whether it is good news
 */
export const DevToolsStatusBadge: React.FC<DevToolsStatusBadgeProps> = ({
  label,
  variant,
  className,
}) => (
  <span className={cn(devToolsStatusBadgeVariants({ variant }), className)}>
    {label}
  </span>
);
